import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function DisclaimerBanner() {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 mr-3 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-amber-900 mb-1">
            Important Compliance Disclaimer
          </h3>
          <p className="text-sm text-amber-800">
            Standari is a documentation assistance tool. All outputs, validations, and standards information 
            are provided as <strong>guidance only</strong> and do not constitute official certification, 
            guarantee of compliance, or legal advice. Users are solely responsible for ensuring their 
            documentation meets all applicable regulatory requirements. Official validation must be performed 
            by qualified personnel and authorized certification bodies where required.
          </p>
        </div>
      </div>
    </div>
  );
}
